// extracted by css-extract-rspack-plugin
export default {"draggedRow":"zUfnc","dropTargetRow":"ySJSE","disabledRow":"GJqfJ"};